module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel",
    attrs: {
      "id": "student-list"
    }
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_vm._v(_vm._s(_vm.tokens['num_student'](_vm.students)))])]), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.openEditor
    }
  }, [_vm._v(_vm._s(_vm.tokens['add']))])])])])]), _c('div', {
    staticClass: "panel-block is-paddingless"
  }, [(_vm.students === null) ? _c('div', {
    staticClass: "container"
  }, [_c('loading')], 1) : _c('table', {
    staticClass: "table"
  }, [_c('thead', [(_vm.students && _vm.students.length) ? _c('tr', {
    staticClass: "is-subheader"
  }, [_c('th', [_vm._v(_vm._s(_vm.tokens['name']))]), _c('th', {
    staticClass: "is-narrow"
  }, [_c('div', {
    staticClass: "has-text-centered"
  }, [_vm._v(_vm._s(_vm.tokens['assignments']))])]), _c('th', {
    staticClass: "is-narrow"
  })]) : _vm._e()]), _c('tbody', _vm._l((_vm.students), function(student) {
    return _c('tr', {
      key: _vm.currentClass.id + student.id
    }, [_c('td', [_vm._v(_vm._s(student.name))]), _c('td', {
      staticClass: "is-narrow"
    }, [_c('div', {
      staticClass: "tags"
    }, _vm._l((student.assignments), function(cls, task) {
      return (_vm.doesTaskBelongsToClass(task)) ? _c('div', {
        staticClass: "tag is-medium"
      }, [_vm._v(_vm._s(_vm.getAssignmentName(task))), _c('button', {
        staticClass: "delete is-small",
        on: {
          "click": function($event) {
            _vm.removeAssignment(student, task)
          }
        }
      })]) : _vm._e()
    })), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.availableTasks(student).length),
        expression: "availableTasks( student ).length"
      }],
      ref: _vm.currentClass.id + student.id,
      refInFor: true,
      staticClass: "dropdown"
    }, [_c('div', {
      staticClass: "dropdown-trigger",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('button', {
      staticClass: "button",
      attrs: {
        "aria-haspopup": "true",
        "aria-controls": "dropdown-menu"
      },
      on: {
        "click": function($event) {
          _vm.toggleTaskList(_vm.currentClass.id + student.id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.tokens['lbl_add']))]), _vm._m(0, true)])]), _c('div', {
      staticClass: "dropdown-menu",
      attrs: {
        "role": "menu"
      }
    }, [_c('div', {
      staticClass: "dropdown-content"
    }, _vm._l((_vm.availableTasks(student)), function(task) {
      return _c('div', {
        staticClass: "dropdown-item",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.addAssignment(student, task.id, $event)
          }
        }
      }, [_vm._v(_vm._s(task.name))])
    }))])])]), _c('td', {
      staticClass: "is-narrow"
    }, [_c('button', {
      staticClass: "button",
      attrs: {
        "title": _vm.tokens['tit_remove']
      },
      on: {
        "click": function($event) {
          _vm.remove(student)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])
  }))])]), (_vm.isEditing) ? _c('modal-container', {
    attrs: {
      "title": _vm.tokens['tit_students']
    },
    on: {
      "close": _vm.closeEditor
    }
  }, [_c('item-selection-box', {
    attrs: {
      "items": _vm.schoolGrades,
      "multiple": true,
      "single-group": false,
      "item-name": _vm.tokens['data_grade'],
      "subitem-name": _vm.tokens['data_student']
    },
    on: {
      "accept": _vm.addNewStudents
    }
  })], 1) : _vm._e(), _c('temporal-notification', {
    attrs: {
      "type": "danger",
      "show": _vm.showError
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])]), _c('temporal-notification', {
    attrs: {
      "type": "success",
      "show": _vm.showSuccess
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.successMessage))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-332a2e2e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/StudentList.vue
// module id = 412
// module chunks = 0